import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Menu,
  MenuItem,
  Slide,
  Select,
  Button,
  Dialog,
  ListItemText,
  List,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../Components/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MUIDataTable from "mui-datatables";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EventNoteIcon from "@mui/icons-material/EventNote";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useLocalStorageContext } from "../../Context/LocalProvider";
import { DriverApis, leadSalesApis } from "../../Data/axios";
import config from "../../Data/AuthUser";
import { categoryType } from "../../utils/customers";
import StatusAlert from "../../StatusAlertList/StatusAlert";
import SalesHeader from "./SalesHeader";
import "./Leads.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Sales() {
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const { data: userData } = useLocalStorageContext();
  const navigate = useNavigate();

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [followAgent, setFollowAgent] = useState("");
  const [followDate] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [leadFiles, setLeadFiles] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pageValue, setPageValue] = useState(1);
  const [rowCountValue, setRowCountValue] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selection, setSelection] = useState(null);
  const [selectionStatus, setSelectionStatus] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [followup, setFollowup] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleChangeSelected = async (event, ticketId) => {
    const selectedValue = event.target.value;
    const itemStatus = { status: selectedValue };
    const formData = new FormData();

    for (const key in itemStatus) {
      if (itemStatus[key] !== undefined && itemStatus[key] !== null) {
        formData.append(key, itemStatus[key]);
      }
    }

    await DriverApis.changeStatus(ticketId, formData);
    showAlert("Updated successfully", "success");
    getData();
  };

  const handleFollowup = () => setFollowup(true);
  const handleUpdateCloseFollow = () => setFollowup(false);
  const handleOpenMenu = (id) => setOpenMenuId(id);
  const handleCloseMenu = () => setAnchorEl(null);

  const handleViewMore = async (id) => {
    const userData = leadFiles.find((row) => row.user_id === openMenuId);
    navigate(`/leads/sales/${openMenuId}`, {
      state: {
        ID: openMenuId,
        Username: userData?.username,
      },
    });
  };

  const handleSaleNote = () => {
    const rowData = leadFiles.find((row) => row.id === openMenuId);
    navigate(`/leads/sales/${openMenuId}`, { state: rowData });
  };

  const Savefollowup = async () => {
    const formData = new FormData();
    const time = new Date();
    formData.append("follow_agent", followAgent);
    formData.append("follow_date", followDate);
    formData.append("assigned_by", userData.empid);
    formData.append("assigned_at", time);

    try {
      await leadSalesApis.followUpbyId(openMenuId, formData);
      showAlert("Followup updated successfully", "success");
      handleUpdateCloseFollow();
      getData();
    } catch {
      showAlert("Failed to get Sales Data", "error");
    }
  };

  const getData = useCallback(async () => {
    try {
      const response = await leadSalesApis.getAll(
        pageValue,
        rowsPerPage,
        selection?.props?.value,
        searchValue,
        selectionStatus?.props?.value,
        startDate,
        endDate
      );

      if (response?.status === 1600) {
        setLeadFiles(response?.data?.data);
        setTotalPages(response?.data?.last_page);
        setRowCountValue(response?.data?.total);
        setRowsPerPage(response?.data?.per_page);
      } else {
        throw new Error(`Unexpected response: ${response?.status}`);
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);

      if (error.response) {
        const { status } = error.response;

        if (status === 400) {
          showAlert("Invalid request parameters.", "error");
        } else if (status === 404) {
          showAlert("No data available.", "error");
        } else if (status === 403) {
          showAlert("You do not have permission.", "error");
        } else {
          showAlert("An unknown error occurred", "error");
        }
      } else if (error.request) {
        showAlert("No response from server. Please try again later.", "error");
      } else {
        showAlert("An unexpected error occurred. Please try again.", "error");
      }
    }
  }, [
    pageValue,
    rowsPerPage,
    searchValue,
    selection?.props?.value,
    selectionStatus?.props?.value,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = [
    {
      name: "user_id",
      label: "Name",
      options: {
        customBodyRender: (value) => {
          const fullRecord = leadFiles.find((item) => item.user_id === value);
          if (!fullRecord) return <div>Loading...</div>;

          const imageUrl = `${config.apiImageUrl}${fullRecord.image}`;
          return (
            <div style={{ display: "flex", alignItems: "center",cursor: "pointer" }}
            onClick={() =>
              navigate(`/leads/sales/${fullRecord.user_id}`, {
                state: {
                  ID: fullRecord.user_id,
                  Username: fullRecord.username,
                },
              })
            }>
              <img
                src={imageUrl}
                alt={fullRecord?.username}
                style={styles.avatar}
              />
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {fullRecord.username || "Unknown"}
                </div>
                <div style={{ color: "gray" }}>
                  {fullRecord.user_id || "Unknown"}
                </div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "phone",
      label: "Phone No.",
      options: {
        customBodyRender: (value) => (
          <div style={styles.centerAlign}>{value || " "}</div>
        ),
      },
    },
    {
      name: "role",
      label: "Role",
      options: {
        customBodyRender: (value) => (
          <div style={styles.centerAlign}>{categoryType[value]}</div>
        ),
      },
    },
    {
      name: "followups",
      label: "Followed By",
      options: {
        customBodyRender: (value) => {
          const fullRecord = value[0]?.followup_by;
          if (!fullRecord) return <div style={styles.centerAlign}>---</div>;

          const imageUrl = `${config.apiImageUrl}${fullRecord.image}`;
          return (
            <div style={styles.centerAlign}>
              <img
                src={imageUrl}
                alt={fullRecord?.name}
                style={styles.avatar}
              />
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {fullRecord.name || "Unknown"}
                </div>
                <div style={{ color: "gray" }}>
                  {fullRecord.role || "Unknown"}
                </div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "Status",
      label: "Status",
      options: {
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[0];
          return (
            <div style={styles.centerAlign}>
              <Select
                value={value}
                onChange={(event) => handleChangeSelected(event, ticketId)}
                displayEmpty
                renderValue={(selected) =>
                  selected === "1" ? "Enabled" : "Disabled"
                }
                sx={styles.select}
              >
                <MenuItem value={1}>Enabled</MenuItem>
                <MenuItem value={2}>Disabled</MenuItem>
              </Select>
            </div>
          );
        },
      },
    },
    {
      name: "user_id",
      label: "Action",
      options: {
        customBodyRender: (value) => (
          <div style={styles.actionContainer}>
            <Button onClick={(e) => setAnchorEl(e.currentTarget)}>
              <div onClick={() => handleOpenMenu(value)}>
                <MoreHorizTwoToneIcon />
              </div>
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              {userPermissions?.sales_view !== 0 && (
                <MenuItem onClick={handleCloseMenu}>
                  <div
                    onClick={() => handleViewMore(value)}
                    style={styles.menuItem}
                  >
                    <RemoveRedEyeIcon /> View More
                  </div>
                </MenuItem>
              )}
              {userPermissions?.sales_note !== 0 && (
                <MenuItem onClick={handleCloseMenu}>
                  <div onClick={handleSaleNote} style={styles.menuItem}>
                    <EventNoteIcon /> Note
                  </div>
                </MenuItem>
              )}
              {userPermissions?.sales_follow_up !== 0 && (
                <MenuItem onClick={handleCloseMenu}>
                  <div onClick={handleFollowup} style={styles.menuItem}>
                    <GroupAddIcon /> Follow up
                  </div>
                </MenuItem>
              )}
            </Menu>
          </div>
        ),
      },
    },
  ];

  const options = {
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    selectableRows: "none",
    rowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 100],
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPageValue(0);
    },
    onChangePage: (currentPage) => setPageValue(currentPage + 1),
    customFooter: (
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => (
      <div style={styles.footer}>
        <span>
          Showing {page * rowsPerPage + 1} -{" "}
          {Math.min(rowCountValue, (page + 1) * rowsPerPage)} of {rowCountValue}{" "}
          entries
        </span>
        <div style={styles.pagination}>
          <label htmlFor="rowsPerPage">Rows per page: </label>
          <select
            id="rowsPerPage"
            value={rowsPerPage}
            onChange={(e) => changeRowsPerPage(Number(e.target.value))}
          >
            {[5, 10, 25, 100].map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <Button
            variant="outlined"
            onClick={() => changePage(page - 1)}
            disabled={page === 0}
            sx={styles.paginationButton}
          >
            Previous
          </Button>
          <Button
            variant="outlined"
            onClick={() => changePage(page + 1)}
            disabled={page + 1 === totalPages}
            sx={styles.paginationButton}
          >
            Next
          </Button>
        </div>
      </div>
    ),
  };

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <SalesHeader
        startDate={startDate}
        selection={selection}
        setSelection={setSelection}
        selectionStatus={selectionStatus}
        setSelectionStatus={setSelectionStatus}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <Box sx={{ zIndex: 11000 }}>
        <Dialog
          open={followup}
          fullWidth
          maxWidth="md"
          onClose={handleUpdateCloseFollow}
          TransitionComponent={Transition}
          PaperProps={{ style: styles.dialogPaper }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateCloseFollow}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} component="div">
                Follow Up
              </Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{ backgroundColor: "white" }}>
            <Grid container spacing={2} style={styles.gridContainer}>
              <Grid item xs={8} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Follow Agent
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="ex. abc"
                  onChange={(e) => setFollowAgent(e.target.value)}
                  inputProps={{ style: styles.input }}
                  sx={styles.textField}
                />
              </Grid>
              <Grid item xs={8} sm={4}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Follow Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker label="Date" />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Button
              variant="contained"
              onClick={Savefollowup}
              sx={styles.saveButton}
            >
              Save
            </Button>
          </Box>
        </Dialog>
      </Box>
      <List style={styles.list}>
        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={<span style={styles.title}>Sales Lists</span>}
              data={leadFiles}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

const styles = {
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
    marginRight: "10px",
  },
  centerAlign: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  select: {
    width: "110px",
    border: "none",
    color: "#000",
    bgcolor: "#fff",
    "& .MuiSelect-select": { padding: 0.5 },
  },
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: "0",
  },
  menuItem: {
    display: "flex",
    justifyContent: "space-center",
    alignItems: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paginationButton: {
    margin: "0 5px",
    color: "#1d82f5",
    cursor: "pointer",
    "&:hover": { color: "#000", border: "1px solid black" },
  },
  dialogPaper: {
    position: "absolute",
    background: "#141b2d",
    top: "0",
    backgroundColor: "white",
    maxHeight: "95%",
    margin: "auto",
    overflowX: "hidden",
    zIndex: 1200,
  },
  gridContainer: {
    color: "black",
    margin: "10px",
  },
  input: {
    color: "black",
    border: "1px solid black",
    borderRadius: "5px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderColor: "black",
      "&:hover fieldset": { borderColor: "black" },
      "&.Mui-focused fieldset": { borderColor: "black" },
    },
    "& .MuiOutlinedInput-input": { "&::placeholder": { color: "gray" } },
  },
  saveButton: {
    backgroundColor: "blue",
    "&:hover": { backgroundColor: "orange" },
    textAlign: "center",
    margin: "25px",
  },
  list: {
    background: "none",
    padding: 5,
  },
  title: {
    fontWeight: 700,
    fontSize: "1.5rem",
    color: "#333",
  },
};

const getTheme = () =>
  createTheme({
    palette: {
      mode: "light",
      primary: { main: "#2196f3" },
      secondary: { main: "#03a9f4" },
    },
    typography: {
      fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
    },
    components: {
      MuiButton: { styleOverrides: { root: { textTransform: "none" } } },
    },
  });

export default Sales;
